import { useContext } from 'react';

import { ModalServiceContext, RicosContext } from './../../../ricos-context';
import { getIsModalOpen, useModalState } from './../../../ricos-modals/modal-service-provider';

import { TABLE_BUTTONS_MODALS_ID } from '../../consts';
import type { BorderPanelProps } from './BorderPanel';

export const useBorderPanel = (componentProps: BorderPanelProps) => {
  const { isMobile } = useContext(RicosContext);
  const modalService = useContext(ModalServiceContext);
  const isModalOpen = useModalState(getIsModalOpen(TABLE_BUTTONS_MODALS_ID.BORDER));

  const toggleModal = (referenceElement: HTMLElement | null) => {
    modalService.isModalOpen(TABLE_BUTTONS_MODALS_ID.BORDER)
      ? modalService.closeModal(TABLE_BUTTONS_MODALS_ID.BORDER)
      : modalService.openRegisteredModal(TABLE_BUTTONS_MODALS_ID.BORDER, {
          componentProps,
          layout: isMobile ? 'drawer' : 'toolbar',
          positioning: { referenceElement, placement: 'bottom' },
        });
  };

  return { toggleModal, isModalOpen };
};
